import { EnvironmentRepository } from 'core/repositories/EnvironmentRepository';
import { Environment } from 'core/models/environment';
import { ApiCall } from './api/apiCall';
import { Project } from 'core/models/project';
import { EnvironmentResponse } from './api/FMS';

class ApiEnvironmentRepository implements EnvironmentRepository {
    private readonly apiCall: ApiCall;

    constructor(apiCall: ApiCall) {
        this.apiCall = apiCall;
    }

    async getEnvironments(projectId: Project.Id): Promise<Environment[]> {
        try {
            const res = await this.apiCall<EnvironmentResponse>(`/v1/projects/${projectId}/environments`);
            return res.map(e => ({ id: e.environment_id, name: e.environment_name }));
        } catch (e) {
            console.warn(e);
            return [];
        }
    }
}

export { ApiEnvironmentRepository as EnvironmentRepository };
